import { render } from "./FlowEmptyState.vue?vue&type=template&id=baf3f104&scoped=true"
import script from "./FlowEmptyState.vue?vue&type=script&lang=ts"
export * from "./FlowEmptyState.vue?vue&type=script&lang=ts"

import "./FlowEmptyState.vue?vue&type=style&index=0&id=baf3f104&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-baf3f104"

export default script